export function getParentPathname(path = '') {
	const parts = (path || '').split('/')

	const sliceUntil = parts[parts.length - 1] === '' || parts[parts.length - 1].startsWith('#') ? -2 : -1

	return parts.slice(0, sliceUntil).join('/')
}

export default function getParentLocation(location) {
	const parentPathname = getParentPathname(`${location.pathname}${location.hash}`)
	return {
		...location,
		key: 'parent',
		href: `${location.origin}${parentPathname}`,
		pathname: parentPathname,
		search: '',
		hash: '',
	}
}
